import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Heading = styled(Box)(_templateObject(), theme("Heading"));
var Heading$1 = use(Heading, "h1");
export default Heading$1;